<template>
  <div>
    <div class="mt-4 mb-4 heading-items">
      <div class="title">
        <span class="header-title mb-4">
          Your estimated Citrix DaaS on Google Cloud costs
        </span>
      </div>
      <div class="btns-wrapper">
        <div class="button-icons">
          <span class="btn-icons">
            <PrintIcon class="cursor-pointer" @click="printPage" />
          </span>
        </div>
        <div class="modify-btn">
          <Button variant="primary" @click="modifyInput">
            Modify Input
          </Button>
        </div>
      </div>
    </div>
    <HorizontalTile :data="headerTileData" />
    <div class="graph-section-wrapper mt-5">
      <div class="graph-wrapper">
        <MainGraphCard :data="mainGraphData" />
      </div>
      <div class="right-tile-wrapper">
        <VerticalTiles :data="rightTilesData" />
      </div>
    </div>
    <div>
      <TabView />
    </div>
  </div>
</template>

<script>
import MailIcon from '../../assets/icons/mail-icon.svg';
import DownloadIcon from '../../assets/icons/download-icon.svg';
import PrintIcon from '../../assets/icons/print-icon.svg';
import Button from '../input-controls/Button.vue';
import HeaderName from '../global/HeaderName.vue';
import HorizontalTile from '../containers/HorizontalTile.vue';
import TabView from '../containers/TabView.vue';
import MainGraphCard from '../containers/MainGraphCard.vue';
import VerticalTiles from '../containers/VerticalTiles.vue';
import store from '../../store/index';
import { cvadCostCalculationFunction } from '../../services/lib/CVADcalculation';

export default {
  name: 'Result',
  data() {
    return {
      headerTileData: {
        regions: 0,
        personas: 0,
        users: 0,
        term: 3,
      },
      perUserPerMonth: [
        { id: 'cvad', title: 'Citrix cost', amount: 0 },
        { id: 'gcp', title: 'CGP Cost', amount: 0 },
        { id: 'total', title: 'Total Cost', amount: 0 },
      ],
      cvadCost: 0,
      cvadCostPerUser: 0,
      gcpCost: {
        compute: 0,
        storage: 0,
      },
      estimatedCost: [],
      rightTilesData: {
        cvadCost: 0,
        cvadCostPerUserPerYear: 0,
        users: 0,
        gcpCostPerYear: 0,
        totalCvadThreeYear: 0,
      },
      mainGraphData: {
        totalCvadThreeYear: 0,
        estimatedCost: [],
        cvadCost: 0,
        gcpCost: {
          compute: 0,
          storage: 0,
        },
      },
    };
  },

  components: {
    HeaderName,
    MailIcon,
    DownloadIcon,
    PrintIcon,
    Button,
    HorizontalTile,
    TabView,
    MainGraphCard,
    VerticalTiles,
  },

  props: {},

  mounted() {
    if (store.state.personaDataAfterCalculate.length === 0) {
      this.$router.push({ path: '/' });
    }
    let region = [];
    let user = 0;

    //for cvad calculation each persona cvadpermonth value is calculated and added in this variable
    var totalCvadCostPerYear = 0;
    var totalCvadCostThreeYear = 0;

    var totalCvadPerUserPerYearCost = 0; // for cvad calculation per year per user values
    store.state.personaData.forEach((item, id) => {
      this.mainGraphData.edition = item.pricingModel;

      //calculating the three years data for different pricing model
      /*section start */
      // if (item.pricingModel == 'PAYGO') {
      //per-user per-year
      totalCvadPerUserPerYearCost =
        totalCvadPerUserPerYearCost +
        cvadCostCalculationFunction(item.pricingModel, item.users)
          .cvadCostperUserperYearValue;
      //for 3 years
      totalCvadCostThreeYear =
        totalCvadCostThreeYear +
        cvadCostCalculationFunction(item.pricingModel, item.users).totalCost *
          3;
      // } else {
      //   const totalValueBeforeDiscount =
      //     cvadCostCalculationFunction(item.pricingModel, item.users).totalCost *
      //     3;
      //   const totalValueBeforeDiscountPerYearPerUser = cvadCostCalculationFunction(
      //     item.pricingModel,
      //     item.users
      //   ).cvadCostperUserperYearValue;

      //   const totalValueAfterDiscount =
      //     totalValueBeforeDiscount - totalValueBeforeDiscount * (20 / 100);

      //   const totalValueAfterDiscountPerYearPerUser =
      //     totalValueBeforeDiscountPerYearPerUser -
      //     totalValueBeforeDiscountPerYearPerUser * (20 / 100);

      //   totalCvadPerUserPerYearCost =
      //     totalCvadPerUserPerYearCost + totalValueAfterDiscountPerYearPerUser;

      //   totalCvadCostThreeYear =
      //     totalCvadCostThreeYear + totalValueAfterDiscount;
      // }

      /*section end */

      totalCvadCostPerYear =
        totalCvadCostPerYear +
        cvadCostCalculationFunction(item.pricingModel, item.users).totalCost; //returns peruser per year value and per Year value

      if (region.indexOf(item.regionId) === -1) {
        region.push(item.regionId);
      }

      this.headerTileData.regions = region.length;

      user += Number(item.users);
    });

    this.cvadCost = totalCvadCostPerYear;
    this.headerTileData.personas = store.state.personaData.length;
    this.headerTileData.users = user;

    let compute = 0;
    let storage = 0;
    store.state.personaDataAfterCalculate.forEach(element => {
      let counter = store.state.personaDataAfterCalculate.filter(
        ele => ele.regionId === element.regionId
      ).length;
      compute +=
        element.cloudConnector.compute / counter +
        element.domainController.compute +
        element.netScaler.compute +
        element.storeFront.compute +
        element.vda.compute;

      storage +=
        element.cloudConnector.storage / counter +
        element.domainController.storage +
        element.netScaler.storage +
        element.storeFront.storage +
        element.vda.storage;
    });

    compute = compute * 12;
    storage = storage * 12;

    this.gcpCost.compute = compute;
    this.gcpCost.storage = storage;

    //logic for the right tiles data
    this.rightTilesData.cvadCost = totalCvadCostPerYear;
    this.rightTilesData.cvadCostPerUserPerYear =
      totalCvadPerUserPerYearCost / store.state.personaData.length;
    this.rightTilesData.users = this.headerTileData.users;

    this.rightTilesData.gcpCostPerYear = (compute + storage) / user;

    let totalgcpThreeYear = (compute + storage) * 3;
    this.mainGraphData.estimatedCost.push(
      totalCvadCostThreeYear,
      totalgcpThreeYear
    );
    this.mainGraphData.totalCvadThreeYear = this.convertTonumberwithCommas(
      totalCvadCostThreeYear
    );

    this.rightTilesData.totalCvadThreeYear = totalCvadCostThreeYear;
    this.mainGraphData.cvadCost = this.cvadCost;
    this.mainGraphData.gcpCost.compute = this.gcpCost.compute;
    this.mainGraphData.gcpCost.storage = this.gcpCost.storage;
  },

  methods: {
    modifyInput() {
      this.$router.push({ path: '/' });
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style lang="scss" scoped>
@media print {
  @page {
    size: landscape;
  }
}

.heading-items {
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  @media (max-width: 768px) {
    display: block;
  }

  .btns-wrapper {
    display: flex;
    align-items: baseline;
  }

  .modify-btn {
    text-align: right;
    @media print {
      display: none;
    }
  }
}

.graph-section-wrapper {
  display: grid;
  grid-template-columns: 70% 30%;
  grid-gap: 10px;
  @media print {
    display: grid !important;
    grid-template-columns: 60% 40% !important;
    grid-gap: 10px !important;
  }
  @media (max-width: 1024px) {
    display: block;
  }
}

.btn {
  width: 180px;
}
.btn {
  background: #05758a;
  border-radius: 22px;
  color: #fff;
  outline: none;
  padding: 10px 24px;
  border: none;
  font-size: 18px;
  line-height: 21px;
  font-weight: 400;
}
.header-title {
  font-size: 40px;
  line-height: 46px;
}

@media (max-width: 768px) {
  .header-title {
    font-size: 29px;
  }
  .header-title {
    font-size: 29px;
    line-height: 33px;
  }
}
.product-info {
  font-size: 24px;
}

.button-icons {
  padding: 0%;
  text-align: right;
}

.btn-icons {
  margin: 1em 0;
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  text-align: end;
  @media print {
    display: none;
  }
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none;
}
.modify-input {
  margin-top: -52px;
}

.persona-per-user {
  font-size: 34px;
  margin-top: 0;
  margin-bottom: 0;
}

.cursor-pointer {
  cursor: pointer;
}
@media (max-width: 768px) {
  .button-icons {
    padding: 0%;
    text-align: left;
  }
}
</style>
